export default {
  data() {
    // Key is the property to be debounced, value is the debounce delay in ms
    return { debounced: {} };
  },

  created() {
    this.timers = {};
    this.unwatchers = [];
    for (const [property, delay] of Object.entries(this.debounced)) {
      // Watch the properties for changes, and when they do change, wait before
      // updating the corresponding debounced property. The debounced property will never
      // be updated until [delay] ms have passed since the last change of the underlying property.
      const unwatcher = this.$watch(
        property,
        value => {
          clearTimeout(this.timers[property]);
          this.timers[property] = setTimeout(() => {
            this.updateDebounced(property);
          }, delay);
        },
        { deep: true }
      );
      // Keep a reference to the watchers for cleanup
      this.unwatchers.push(unwatcher);
      // In the beginning, all debounced properties need to get their values immediately
      this.updateDebounced(property);
    }
  },

  // Clean up watchers and timeouts
  beforeDestroy() {
    for (const unwatcher of this.unwatchers) {
      unwatcher();
    }
    for (const timer of Object.values(this.timers)) {
      clearTimeout(timer);
    }
  },

  methods: {
    updateDebounced(property) {
      this.debounced[property] = this[property];
    },
  },
};
